/**
 * Shared shape for runbook step events (RFC-169) — emitted by the
 * server runbook executor, persisted in `StepRunEvent`, fanned out over
 * SSE on the existing `runbook-execution:{executionId}` channel, and
 * rendered by the client step timeline.
 */

export const RUNBOOK_STEP_SSE_EVENT = 'step-event' as const

export type StepEventKind =
  | 'tool-call'
  | 'tool-result'
  | 'tool-error'
  | 'log'

export type StepEventState =
  | 'input-available'
  | 'output-available'
  | 'error'

export interface StepEventPayload {
  kind: StepEventKind
  toolCallId?: string
  toolName?: string
  state?: StepEventState
  input?: unknown
  output?: unknown
  message?: string
  /** Provider/durationMs and other metadata the renderer surfaces inline. */
  meta?: Record<string, unknown>
}

export interface StepEventSseEnvelope {
  executionId: string
  kind: typeof RUNBOOK_STEP_SSE_EVENT
  stepRunId: string
  seq: number
  payload: StepEventPayload
  emittedAt: number
}

export interface StepEventDTO {
  id: string
  stepRunId: string
  seq: number
  payload: StepEventPayload
  createdAt: Date | string
}
